import { MiscellaneousCurrencyConstants } from '@openbank/ziniaweb-ui-core-models';
import { TextComponentType } from '@openbank/ziniaweb-ui-components';

const KYC_BIZUM_LOADER_PROPS = {
    altText: 'loading',
    color: '#00A4A4',
    animation: 'animation_loader_primary',
    width: '50px',
    height: '50px',
  },
  KYC_BIZUM_TITLE_PROPS = {
    component: TextComponentType.H3,
    showBuilder: false,
  },
  KYC_BIZUM_LOGO_PROPS = {
    icon: 'bizum-lightbg',
    altText: 'Alternative text',
    height: '50px',
    width: '140px',
  },
  KYC_BIZUM_AMOUNT_PROPS = {
    ...MiscellaneousCurrencyConstants.AMOUNT_FORMAT_PROPS,
    value: 0.01,
    currency: 'EUR',
  },
  KYC_BIZUM_TIMER_LOCALSTORAGE_ID = 'bizum-timer',
  KYC_BIZUM_WS_TIME_PROPS = {
    timeout: 240,
  };

export {
  KYC_BIZUM_AMOUNT_PROPS,
  KYC_BIZUM_LOADER_PROPS,
  KYC_BIZUM_LOGO_PROPS,
  KYC_BIZUM_TITLE_PROPS,
  KYC_BIZUM_TIMER_LOCALSTORAGE_ID,
  KYC_BIZUM_WS_TIME_PROPS,
};
